import * as React from "react"

const PictureInPicture = (props: any) => {
    const size = props.size || 40;
    return <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 256 256"
        {...props}
    >
        <g
            fill="none"
            strokeWidth="none"
            strokeMiterlimit={10}
            fontFamily="none"
            fontWeight="none"
            fontSize="none"
            textAnchor="none"
            style={{
                mixBlendMode: "normal",
            }}
        >
            <path
                d="M213.333 202.667H42.667C36.779 202.667 32 197.888 32 192V64c0-5.888 4.779-10.667 10.667-10.667h170.666C219.221 53.333 224 58.112 224 64v128c0 5.888-4.779 10.667-10.667 10.667z"
                fill="#7252f7"
                opacity={0.13}
            />
            <path d="M192 170.667h-74.667v-53.334H192z" fill="#7252f7"/>
            <path
                d="M213.333 202.667H42.667C36.779 202.667 32 197.888 32 192V64c0-5.888 4.779-10.667 10.667-10.667h170.666C219.221 53.333 224 58.112 224 64v128c0 5.888-4.779 10.667-10.667 10.667z"
                stroke="#7252f7"
                strokeWidth={21.33334}
                strokeLinejoin="round"
            />
        </g>
    </svg>
}

export default PictureInPicture
